// extracted by mini-css-extract-plugin
export var highlightOriginal = "_redotech-redo-web-lib-address-verification-address-suggestion-highlight-original";
export var highlightSuggested = "_redotech-redo-web-lib-address-verification-address-suggestion-highlight-suggested";